<template>
  <div id="main-app">
  <ToolBar :title="toolbarTitle" :color="toolbarColor"/>
  <v-content> 
      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card class="mt-5">
            <v-card-title primary-title>
              <div>
                <v-icon class="icon-warning">warning</v-icon>
                <h3 class="headline mb-0">OPS! <br>
                {{user.displayName}},</h3>
                <p>
                Este email não está cadastrado</p>
                <h5 class="subheading">{{user.email}}</h5>
              </div>
              <div class="mt-3">Favor entrar em contato com a sua comissão de formatura e solicitar o envio deste email: <br>
              <div class="yellow lighten-4 text-xs-center mt-2 mb-2 subheading">{{user.email}} </div>
                para cadastro no sistema. Obrigado e sucesso!
              </div>
            </v-card-title>
            <v-card-actions>
              <v-btn warning dark large @click='logOut'>Sair</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-content>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar";
export default {
  name: "AppSemCadastro",
  components: {
    ToolBar
  },
  data() {
    return {
      toolbarTitle: "A5 Convites",
      toolbarColor: "white",
      usuario: {},
      user: {},
      emailkey: ""
    };
  },
  mounted() {
    this.$auth.onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        this.emailkey = user.email.replace(/[.]/g, ",");
      } else {
        this.$router.push("/login");
      }
    });
  },
  methods: {
    logOut() {
      this.$auth.signOut().then(() => {
        this.$router.push("/login");
      });
    }
  }
};
</script>

<style lang="stylus">
.icon-warning {
  font-size: 100px !important;
  color: #dd2121 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/AppSemCadastro.vue